import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Calendar, utils } from "@amir04lm26/react-modern-calendar-date-picker";
import "@amir04lm26/react-modern-calendar-date-picker/lib/DatePicker.css";
import "./DatePickerModal.css";


function DatePickerModal(props) {
  let lng = JSON.parse(localStorage.getItem("language"))?.lang;
  const [selectedDay, setSelectedDay] = useState(null);
  const minimumDate = {
    year: 1910,
    month: 4,
    day: 12
  };
  const maximumDate = {
    year: 2004,
    month: 4,
    day: 12
  };
  return (
    <Modal
      show={props.show}
      onHide={props.onHide}
      dialogClassName="DatePickerModalDialog"
      contentClassName="DatePickerModalContent"
      centered
    >
      <Modal.Body className="DatePickerModalBody">
        <Calendar
          value={selectedDay}
          maximumDate={maximumDate}
          minimumDate={minimumDate}
          onChange={(selectedDate) => {
            setSelectedDay(selectedDate);
            props.setSelectedDate(selectedDate);
            props.onHide();
          }}
          calendarClassName="modernCalendar"
          shouldHighlightWeekends
        />
      </Modal.Body>
    </Modal>
  );
}
export default DatePickerModal;
